import React from "react";
import { View, SxProp } from "dripsy";

import { UniAmountDetailsCard } from "../../../packages/design-system/components/cards/UniAmountDetailsCard";
import { UniInputAmount } from "@/design-system/components/inputs/UniInputAmount";

enum StyleName {
  container = "container",
  amountDetailsContainer = "amountDetailsContainer",
}

export interface RedemptionFeeFormProps {
  tenor: string;
  asset: string;
  isLoading?: boolean;
  disabled?: boolean;
  redeemableAmount?: number;
  netRedemptionAmount?: string;
  redemptionInstructionFee?: string;
  onValueChange?: (value?: string) => void;
}

export const RedemptionFeeForm: React.FC<RedemptionFeeFormProps> = (props) => {
  const {
    tenor,
    asset,
    redeemableAmount,
    redemptionInstructionFee,
    netRedemptionAmount,
    onValueChange,
    isLoading,
    disabled,
  } = props;

  if (tenor !== "Flexible") return null;

  return (
    <View sx={styles[StyleName.container]}>
      <UniInputAmount
        labelText="Redemption Amount"
        asset={asset}
        balance={redeemableAmount}
        onValueChange={(value) =>
          onValueChange &&
          onValueChange(value === undefined ? undefined : value.toString())
        }
      />
      <UniAmountDetailsCard
        sx={styles[StyleName.amountDetailsContainer]}
        data={[
          {
            name: "Redemption Instr. Fee",
            amount: redemptionInstructionFee || "",
            currency: asset,
          },
          {
            name: "Net Redemption Amount",
            amount: netRedemptionAmount || "",
            currency: asset,
          },
        ]}
      />
    </View>
  );
};

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    mt: "$5",
    paddingY: "$5",
    borderTopWidth: 1,
    borderTopColor: "$borderPrimary",
  },
  [StyleName.amountDetailsContainer]: {
    mt: "$5",
    mb: "$5",
  },
};
